import { render, staticRenderFns } from "./viewSku.vue?vue&type=template&id=4e36545b&scoped=true"
import script from "./viewSku.vue?vue&type=script&lang=js"
export * from "./viewSku.vue?vue&type=script&lang=js"
import style0 from "./viewSku.vue?vue&type=style&index=0&id=4e36545b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36545b",
  null
  
)

export default component.exports